var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vx-card",
    {
      staticClass: "shadow-lg vs-con-loading__container",
      attrs: { title: _vm.capitalize(_vm.$t("attribute.payment")) }
    },
    [
      _c(
        "div",
        { attrs: { id: "payment-box" } },
        [
          _vm.payment_errors.length > 0
            ? _vm._l(_vm.payment_errors, function(error) {
                return _c(
                  "div",
                  { key: error.message, staticClass: "mb-2" },
                  [
                    _c(
                      "vs-alert",
                      { attrs: { color: "danger", icon: "new_releases" } },
                      [_c("span", [_vm._v(_vm._s(error))])]
                    )
                  ],
                  1
                )
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "w-full mb-3" },
            [
              _vm.payment_method == "PAYNOW"
                ? [
                    _c("img", {
                      staticStyle: {
                        width: "70%",
                        "margin-left": "auto",
                        "margin-right": "auto"
                      },
                      attrs: { src: _vm.$endpoints.paynow_qrcode }
                    })
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.payment_method == "BANK_TRANSFER"
                ? [
                    _c("img", {
                      staticStyle: {
                        width: "70%",
                        "margin-left": "auto",
                        "margin-right": "auto"
                      },
                      attrs: { src: _vm.$endpoints.bank_transfer }
                    })
                  ]
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "vx-row" }, [
            _vm.is_bank_transfer
              ? _c(
                  "div",
                  { staticClass: "vx-col w-full lg:w-1/3" },
                  [
                    _c(
                      "vs-button",
                      {
                        key: "BANK_TRANSFER_" + _vm.payment_method,
                        staticClass: "w-full p-5 m-1",
                        attrs: {
                          disabled: _vm.loadingBtnCheckout,
                          color: _vm.renderPaymentMethodButtonColor(
                            "BANK_TRANSFER"
                          ),
                          type: _vm.renderPaymentMethodButtonType(
                            "BANK_TRANSFER"
                          )
                        },
                        on: {
                          click: function($event) {
                            return _vm.onClickChangePaymentMethod(
                              "BANK_TRANSFER"
                            )
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("account_balance")
                        ]),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "small",
                          { staticClass: "font-bold text-uppercase" },
                          [_vm._v(_vm._s(_vm.$t("attribute.bankTransfer")))]
                        )
                      ]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isPayNow
              ? _c(
                  "div",
                  { staticClass: "vx-col w-full lg:w-1/3" },
                  [
                    _c(
                      "vs-button",
                      {
                        key: "PAYNOW_" + _vm.payment_method,
                        staticClass: "w-full p-5 m-1",
                        attrs: {
                          disabled: _vm.loadingBtnCheckout,
                          color: _vm.renderPaymentMethodButtonColor("PAYNOW"),
                          type: _vm.renderPaymentMethodButtonType("PAYNOW")
                        },
                        on: {
                          click: function($event) {
                            return _vm.onClickChangePaymentMethod("PAYNOW")
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("account_balance")
                        ]),
                        _c("br"),
                        _vm._v(" "),
                        _c("small", { staticClass: "font-bold" }, [
                          _vm._v("PAYNOW")
                        ])
                      ]
                    )
                  ],
                  1
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("vs-divider"),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "vs-button",
            {
              staticClass: "w-full p-3 m-1 font-bold",
              attrs: {
                type: "gradient",
                color: "primary",
                disabled: _vm.loadingBtnCheckout
              },
              on: {
                click: function($event) {
                  return _vm.onClickCheckout()
                }
              }
            },
            [_vm._v("CHECKOUT")]
          )
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }